import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/ContentElements/Accordion/AccordionTable/AccordionTable.css';

export const prototypeName = 'pvd27VrRkXhONk3WJPv7f1ROONxjLzf1Mkyk18J6Sq57Jw3wPNsnvqvG1NMvSO8KPALk1NiGoNqepP8OhoD8Z3X0nbIyx2WoynMM';
export {styles};